import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/lib/apiClient';
import { ErrorService } from '@/lib/errors';
import { CABINET_MEMBER_ME_KEY } from '@/hooks/useCabinetMemberMe';
import { useAuth } from '@/components/AuthProvider';

/**
 * Enregistre côté serveur que l'utilisateur a terminé ou fermé le parcours
 * d'onboarding, puis rafraîchit le cache `GET /cabinet-members/me`.
 *
 * Sans toast : l'utilisateur vient de fermer une bulle, il n'attend rien. Si
 * l'appel échoue, le navigateur garde l'état clos ; seul un autre poste
 * reproposerait le parcours, d'où la remontée silencieuse pour le diagnostic.
 */
export function useCloseOnboardingTour() {
  const queryClient = useQueryClient();
  const { user } = useAuth();
  return useMutation({
    mutationFn: async () => {
      await apiClient.patch('/cabinet-members/onboarding-tour-closed', {});
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [CABINET_MEMBER_ME_KEY] });
      queryClient.invalidateQueries({ queryKey: [CABINET_MEMBER_ME_KEY, user?.id] });
    },
    onError: (err) => {
      ErrorService.handle(err, {
        silent: true,
        context: { action: 'close_onboarding_tour', url: '/cabinet-members/onboarding-tour-closed' },
      });
    },
  });
}
